module.exports = __webpack_public_path__ + "static/media/megan-fox-icon.2b30d066.jpg";